import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import GridItem from 'components/Grid/GridItem';
import React, { Fragment, useEffect, useState } from 'react';
import { wsFindBy } from 'services/WService';

export default function FilterScale(props) {
  //#region listados

  const {
    fullWidth,
    getFilter,
    reqFields,
    provider,
    providerID = null,
    category,
    line,
    family,
    product,
    type = null
  } = props;

  const [dataFilter, setDataFilter] = useState({});

  const [providers, setProviders] = useState([]);
  const [categories, setCategories] = useState([]);
  const [lines, setLines] = useState([]);
  const [families, setFamilies] = useState([]);
  const [products, setProducts] = useState([]);

  async function listProviders() {
    let response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) setProviders(response.data);
  }

  async function listCategories(providerId) {
    let response = await wsFindBy('logi/category', { base_business_partner_id: providerId });
    if (response.success) setCategories(response.data);
  }

  async function listLines(categoryId) {
    let response = await wsFindBy('logi/line', { logi_category_id: categoryId });
    if (response.success) setLines(response.data);
  }

  async function listFamilies(categoryId) {
    let response = await wsFindBy('logi/family', { logi_category_id: categoryId });
    if (response.success) setFamilies(response.data);
  }

  async function listProducts(filter) {
    let response = await wsFindBy('logi/product', filter);
    if (response.success) setProducts(response.data);
  }

  useEffect(() => {
    if (provider) listProviders();
    /* if (category) listCategories();
    if (line) listLines();
    if (family) listFamilies(); */
  }, [provider]);
  //#endregion

  const handleChange = (field, value) => {
    if (field === 'base_business_partner_id') {
      const {
        base_business_partner_id,
        logi_category_id,
        logi_line_id,
        logi_family_id,
        logi_product_id,
        ...rest
      } = dataFilter;
      if (value) {
        if (category) listCategories(value);
        setDataFilter({ ...rest, [field]: value });
      } else {
        setCategories([]);
        setDataFilter(rest);
      }
    }

    if (field === 'logi_category_id') {
      const {
        logi_category_id,
        logi_line_id,
        logi_family_id,
        logi_product_id,
        ...rest
      } = dataFilter;
      if (value) {
        if (line) listLines(value);
        if (family) listFamilies(value);
        setDataFilter({ ...rest, [field]: value });
      } else {
        setLines([]);
        setDataFilter(rest);
      }
    }

    if (field === 'logi_line_id') {
      const { logi_line_id, logi_product_id, ...rest } = dataFilter;
      if (value) {
        setDataFilter({ ...rest, [field]: value });
      } else {
        setDataFilter(rest);
      }
    }

    if (field === 'logi_family_id') {
      const { logi_family_id, logi_product_id, ...rest } = dataFilter;
      if (value) {
        setDataFilter({ ...rest, [field]: value });
      } else {
        setDataFilter(rest);
      }
    }

    if (field === 'logi_product_id') {
      const { logi_product_id, ...rest } = dataFilter;
      if (value) {
        setDataFilter({ ...rest, [field]: value });
      } else {
        setDataFilter(rest);
      }
    }
  };

  useEffect(() => {
    if (Object.keys(dataFilter).length > 0) {
      getFilter(dataFilter);
      if (product) listProducts(dataFilter);
    }
  }, [dataFilter, product]);

  useEffect(() => {
    if (providerID) {
      setDataFilter({ base_business_partner_id: providerID });
      if (category) listCategories(providerID);
    }
  }, [type]);

  return (
    <Fragment>
      {provider ? (
        <GridItem xs={12} md={fullWidth ? 12 : 2}>
          <Autocomplete
            options={providers}
            getOptionLabel={(option) => option.CardName}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Proveedor"
                margin="normal"
                required={reqFields ? reqFields.includes('provider') : false}
                size="small"
              />
            )}
            onChange={(e, item) => {
              if (item) handleChange('base_business_partner_id', item.id);
              else handleChange('base_business_partner_id', null);
            }}
          />
        </GridItem>
      ) : undefined}

      {category ? (
        <GridItem xs={12} md={fullWidth ? 12 : 2}>
          <Autocomplete
            key={categories + dataFilter.base_business_partner_id}
            options={categories}
            getOptionLabel={(option) => option.description}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Categoría"
                margin="normal"
                required={reqFields ? reqFields.includes('category') : false}
                size="small"
              />
            )}
            onChange={(e, item) => {
              if (item) handleChange('logi_category_id', item.id);
              else handleChange('logi_category_id', null);
            }}
            disabled={!dataFilter.base_business_partner_id}
          />
        </GridItem>
      ) : undefined}

      {line ? (
        <GridItem xs={12} md={fullWidth ? 12 : 2}>
          <Autocomplete
            key={lines + dataFilter.logi_category_id + dataFilter.base_business_partner_id}
            options={lines}
            getOptionLabel={(option) => option.description}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Línea"
                margin="normal"
                required={reqFields ? reqFields.includes('line') : false}
                size="small"
              />
            )}
            onChange={(e, item) => {
              if (item) handleChange('logi_line_id', item.id);
              else handleChange('logi_line_id', null);
            }}
            disabled={!dataFilter.logi_category_id}
          />
        </GridItem>
      ) : undefined}

      {family ? (
        <GridItem xs={12} md={fullWidth ? 12 : 2}>
          <Autocomplete
            key={families + dataFilter.logi_category_id + dataFilter.base_business_partner_id}
            options={families}
            getOptionLabel={(option) => option.description}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Familia"
                margin="normal"
                required={reqFields ? reqFields.includes('family') : false}
                size="small"
              />
            )}
            onChange={(e, item) => {
              if (item) handleChange('logi_family_id', item.id);
              else handleChange('logi_family_id', null);
            }}
            disabled={!dataFilter.logi_category_id}
          />
        </GridItem>
      ) : undefined}

      {product ? (
        <GridItem xs={12} md={fullWidth ? 12 : 2}>
          <Autocomplete
            key={
              products +
              dataFilter.base_business_partner_id +
              dataFilter.logi_category_id +
              dataFilter.logi_line_id +
              dataFilter.logi_family_id
            }
            options={products}
            getOptionLabel={(option) => option.ItemName}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Producto"
                margin="normal"
                required={reqFields ? reqFields.includes('product') : false}
                size="small"
              />
            )}
            onChange={(e, item) => {
              if (item) handleChange('logi_product_id', item.id);
              else handleChange('logi_product_id', null);
            }}
            disabled={!dataFilter.base_business_partner_id}
          />
        </GridItem>
      ) : undefined}
    </Fragment>
  );
}
